<template>
  <div>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>库存信息</b>
      </div>
      <div class=' contijiao wkbmf loaded' v-if="tibaoif">
        <div class='stamp'> </div>
      </div>

      <el-row class="rowdig">
        <el-col :span="8" class="infodata1">
          <span><b>单号:</b></span> <span>{{informdata.ccode}}</span>
        </el-col>
        <el-col :span="8" class="infodata1">
          <span><b>工厂:</b></span> <span>{{informdata.cfactory}}</span>
        </el-col>
        <el-col :span="8" class="infodata1">
          <span><b>库存截止日期:</b></span> <span>{{informdata.dstockdate}}</span>
        </el-col>
        <el-col :span="8" class="infodata1">
          <span><b>下发通知日期:</b></span> <span>{{informdata.dstockdate}}</span>
        </el-col>
        <el-col :span="8" class="infodata1">
          <span><b>提报截止日期:</b></span> <span>{{informdata.dsubmitdate}}</span>
        </el-col>
        <el-col :span="8" class="infodata1">
          <span><b>是否已提报:</b></span> <span>{{informdata.cvensubmit}}</span>
        </el-col>
        <el-col :span="8" class="infodata1">
          <span><b>实际提报日期:</b></span> <span>{{informdata.dvensubmitdate}}</span>
        </el-col>
        <el-col :span="24" class="">
          <span style="width:75px;"><b>备注:</b></span>
          <span
            style="display: block;width: calc( 100% - 100px);float: right;vertical-align: top;margin-left: 0;">{{informdata.cremaks}}</span>
        </el-col>
      </el-row>
      <div style="width:100%;display:none">
        <el-form :inline="true" :model="informdata" class="demo-form-inline itemwidth infodata" label-width="100px">
          <el-form-item label="单号">
            <el-input v-model="informdata.ccode" placeholder="单号" disabled></el-input>
          </el-form-item>
          <el-form-item label="工厂">
            <el-input v-model="informdata.cfactory" placeholder="工厂" disabled></el-input>
          </el-form-item>
          <el-form-item label="库存截止日期">
            <el-input v-model="informdata.dstockdate" placeholder="库存截止日期" disabled></el-input>
          </el-form-item>
          <el-form-item label="下发通知日期">
            <el-input v-model="informdata.dsubmitdate" placeholder="下发通知日期" disabled></el-input>
          </el-form-item>
          <el-form-item label="提报截止日期">
            <el-input v-model="informdata.dstopdate" placeholder="提报截止日期" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否已提报">
            <el-input v-model="informdata.cvensubmit" placeholder="是否已提报" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际提报日期">
            <el-input v-model="informdata.dvensubmitdate" placeholder="实际提报日期" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="日期">
            <el-input v-model="quoform.ddate" placeholder="日期" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="备注" class="cremark">
            <el-input v-model="informdata.cremaks" type="textarea" placeholder="备注" disabled
              style="width:470px"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>库存填报</b>
      </div>
      <div class="text item text-center" style="width:100%;height:60px;">
        <div class="pull-right" style="margin-bottom:15px">
          <el-button type="success" plain @click.native="checktable('1')" size="medium"
            :disabled="tibaoif">暂存</el-button>
          <el-button type="primary" @click.native="checktable('2')" size="medium" :disabled="tibaoif">提交</el-button>
          <el-button type="danger" plain @click.native="UnPriceSubmit()" size="medium"
            :disabled="!tibaoif">撤销</el-button>
          <el-button type="primary" @click.native="exportExcel()" size="medium">Excel导出</el-button>
          <!-- <el-button type="primary" @click.native="Importtable()" size="medium" :disabled="tibaoif">导入</el-button> -->
          <el-upload action="#" style="display:inline-block;margin:0 10px" v-if="!tibaoif" :show-file-list="false"
            ref="uploadFail" accept=".xls,.xlsx" :before-upload="brforeUploadreImportFail" :auto-upload="false"
            :on-change="handleChangeFail" :file-list="fileListFail">
            <el-button type="success" plain size="medium">Excel导入</el-button>
          </el-upload>
          <!-- <el-button type="danger" @click.native="GetErrorInfo()" size="medium" v-if="!tibaoif">导出错误信息</el-button> -->
          <el-button type="info" plain size="medium" @click="returnpage('1')">返回主表</el-button>
          <el-button type="info" plain size="medium" @click="returnpage('2')">返回首页</el-button>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%;background: transparent" max-height="420"
        :summary-method="getSummaries" show-summary :header-cell-style="{background:'#eef1f6',color:'#606266'}" border
        class="tb-edit" row-key="id" :row-class-name="rowClassName" highlight-current-row>
        <el-table-column prop="id" label="序号" width="50"></el-table-column>
        <el-table-column label="物料编码" prop="cinvcode_3" width="140"></el-table-column>
        <el-table-column label="物料信息" prop="cinvname_3"></el-table-column>
        <el-table-column label="计量单位" prop="cinvunit_3" width="110"></el-table-column>
        <!--  align="center" header-align="left" -->
        <el-table-column label="半成品" width="110" prop="ibanchengpin_3" align="center">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.ibanchengpin_3" v-if="!tibaoif"
              oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
            <span>{{scope.row.ibanchengpin_3}}</span>
          </template>
        </el-table-column>
        <el-table-column label="成品" width="110" prop="ichengpin_3" align="center">
          <template slot-scope=" scope">
            <el-input size="small" v-model="scope.row.ichengpin_3" v-if="!tibaoif"
              oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
            <span>{{scope.row.ichengpin_3}}</span>
          </template>
        </el-table-column>
        <el-table-column label="在途" width="110" prop="izaitu_3" align="center">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.izaitu_3" v-if="!tibaoif"
              oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
            <span>{{scope.row.izaitu_3}}</span>
          </template>
        </el-table-column>
        <el-table-column label="已下单未生产" width="150" prop="iyxdwsc_3" align="center">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.iyxdwsc_3" v-if="!tibaoif"
              oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
            <span>{{scope.row.iyxdwsc_3}}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="cnote_3">
          <template slot-scope="scope">
            <el-input size="small" type="textarea" v-model="scope.row.cnote_3" placeholder="请输入备注"
              v-if="!tibaoif"></el-input>
            <span>{{scope.row.cnote_3}}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-table :data="tableData" style="width: 100%;display:none" id="out-table" class="tablecenter" border
        :cell-style="{ padding: '7px 0'}" :header-cell-style="{ background: '#eef1f6' }">
        <el-table-column label="物料编码" prop="cinvcode_3" width="110"></el-table-column>
        <el-table-column label="物料信息" prop="cinvname_3"></el-table-column>
        <el-table-column label="计量单位" prop="cinvunit_3" width="110"></el-table-column>
        <el-table-column label="半成品" width="110" prop="ibanchengpin_3"></el-table-column>
        <el-table-column label="成品" width="110" prop="ichengpin_3"></el-table-column>
        <el-table-column label="在途" width="110" prop="izaitu_3"></el-table-column>
        <el-table-column label="已下单未生产" width="150" prop="iyxdwsc_3"></el-table-column>
        <el-table-column label="备注" prop="cnote_3"></el-table-column>
      </el-table>

    </el-card>
    <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" customClass="assoformwarp" title="错误信息列表">

      <div class="pull-right" style="margin-bottom:15px;margin-top:-15px;">
        <el-button type="danger" @click="exportExcelerror()">导出excel</el-button>
      </div>
      <el-table :data="errordatajson" style="width: 100%;" max-height="420" class="tablecenter" border
        :cell-style="{ padding: '7px 0'}" :header-cell-style="{ background: '#eef1f6' }">
        <el-table-column prop="iorder" label="序号" width="50"></el-table-column>
        <el-table-column label="物料编码" prop="cinvcode" width="110"></el-table-column>
        <el-table-column label="物料信息" prop="cinvname" width="220"></el-table-column>
        <el-table-column label="半成品" width="90" prop="ibanchengpin"></el-table-column>
        <el-table-column label="成品" width="90" prop="ichengpin"></el-table-column>
        <el-table-column label="在途" width="90" prop="izaitu"></el-table-column>
        <el-table-column label="已下单未生产" prop="iyxdwsc"></el-table-column>
        <el-table-column label="备注" prop="cnote"></el-table-column>
        <el-table-column label="错误信息" prop="cerror">
          <template slot-scope="scope">
            <span style="color:red">{{scope.row.cerror}}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-table :data="errordatajson" style="width: 100%;display:none" id="out-table1" max-height="420"
        class="tablecenter" border :cell-style="{ padding: '7px 0'}" :header-cell-style="{ background: '#eef1f6' }">
        <el-table-column label="物料编码" prop="cinvcode" width="110"></el-table-column>
        <el-table-column label="物料信息" prop="cinvname" width="220"></el-table-column>
        <el-table-column label="半成品" width="90" prop="ibanchengpin"></el-table-column>
        <el-table-column label="成品" width="90" prop="ichengpin"></el-table-column>
        <el-table-column label="在途" width="90" prop="izaitu"></el-table-column>
        <el-table-column label="已下单未生产" width="150" prop="iyxdwsc"></el-table-column>
        <el-table-column label="备注" prop="cnote"></el-table-column>
        <el-table-column label="错误信息" prop="cerror"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad()">关 闭</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { RemovePruchaseToDo } from "../../../../api/home";
  import FileSaver from "file-saver";
  import XLSX from "xlsx";
  export default {
    data() {
      return {
        informdata: {
          ccode: "",
          cvensubmit: "",
          dstockdate: "",
          dvensubmitdate: "",
          dsubmitdate: "",
          cremaks: "",
          dstopdate: "",
        },
        tableData: [],
        tibaoif: false,
        suprow: {},
        previnformdata: {},
        fileListFail: [],
        fileContent: "",
        exceldata: [],
        errordatajson: [],
        dialogFormVisible: false,
      };
    },
    created() {
      if (this.$route.params.rows) {
        this.suprow = this.$route.params.rows;
        sessionStorage.setItem("suprow", JSON.stringify(this.$route.params.rows));

        if (this.$route.params.informdata != "undefined") {
          this.previnformdata = this.$route.params.informdata;
          sessionStorage.setItem(
            "informdata",
            JSON.stringify(this.$route.params.informdata)
          );
        }
      } else {
        if (sessionStorage.getItem("informdata") != "undefined") {
          this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
        }
        if (sessionStorage.getItem("suprow") != "undefined") {
          this.suprow = JSON.parse(sessionStorage.getItem("suprow"));
        }
      }
      this.GetInquiryInfo();
    },
    methods: {
      // 返回
      returnpage(type) {
        sessionStorage.removeItem("params");
        if (type == "1") {
          this.$router.push({
            path: "/FactorypricingList/FactorypricingList",
            query: { informdata: this.previnformdata },
          });
        } else {
          this.$router.push({ path: "/home" });
        }
      },

      // 获取信息
      GetInquiryInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetSubmitStock",
          data: { KeyId: this.suprow.id },
        }).then((res) => {
          console.log(res, "获取信息结果1111111111111111");
          this.loading = false;
          if (res.data.Success) {
            this.informdata = res.data.Data.dataMin[0];
            this.tableData = res.data.Data.dataTable;
            if (this.informdata.cvensubmit == "已提报") {
              this.tibaoif = true;
            } else {
              this.tibaoif = false;
            }
            this.tableData.forEach((item, index) => {
              if (item.cisdeliver == "") {
                item.cisdeliver = "供货";
              }
            });
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      //导入文件
      handleChangeFail(file) {
        console.log(file);
        this.fileContent = file.raw;
        const fileName = file.name;
        const fileType = fileName.substring(fileName.lastIndexOf(".") + 1);
        if (this.fileContent) {
          if (fileType === "xlsx" || fileType === "xls") {
            this.importfile(this.fileContent);
          } else {
            this.$message({
              type: "warning",
              message: "附件格式错误，请重新上传！",
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: "请上传附件！",
          });
        }
      },
      // 获取excel表内容
      importfile(obj) {
        console.log(obj);
        const reader = new FileReader();
        const _this = this;
        reader.readAsArrayBuffer(obj);
        reader.onload = function () {
          const buffer = reader.result;
          const bytes = new Uint8Array(buffer);
          const length = bytes.byteLength;
          let binary = "";
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          const XLSX = require("xlsx");
          const wb = XLSX.read(binary, {
            type: "binary",
          });
          const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          this.exceldata = [...outdata];
          let objarry = Object.keys(this.exceldata[0]);
          for (var i = 0; i < objarry.length; i++) {
            if (objarry[i] == "__EMPTY") {
              _this.$message.error(
                "文件上传失败，缺少表头，请检查excel文件数据是否正确！"
              );
              return false;
            }
          }
          for (let a = 0; a < this.exceldata.length; a++) {
            if (this.exceldata[a].半成品 == undefined) {
              _this.$message.error("文件上传失败，文件中半成品不能为空！");
              return false;
            }
            if (this.exceldata[a].在途 == undefined) {
              _this.$message.error("文件上传失败，文件中在途不能为空！");
              return false;
            }
            if (this.exceldata[a].已下单未生产 == undefined) {
              _this.$message.error("文件上传失败，文件中已下单未生产不能为空！");
              return false;
            }
            if (this.exceldata[a].成品 == undefined) {
              _this.$message.error("文件上传失败，文件中成品不能为空！");
              return false;
            }
            if (this.exceldata[a].物料信息 == undefined) {
              _this.$message.error("文件上传失败，文件中物料信息不能为空！");
              return false;
            }

            if (this.exceldata[a].物料编码 == undefined) {
              _this.$message.error("文件上传失败，文件中物料编码不能为空！");
              return false;
            }
            if (this.exceldata[a].计量单位 == undefined) {
              _this.$message.error("文件上传失败，文件中计量单位不能为空！");
              return false;
            }
            if (this.exceldata[a].计量单位 == undefined) {
              _this.$message.error("文件上传失败，文件中计量单位不能为空！");
              return false;
            }
            if (this.exceldata[a].备注 == undefined) {
              _this.$set(this.exceldata[a], "备注", "");
            }
            if (a == this.exceldata.length - 1) {
              console.log(this.exceldata);
              _this.$refs.uploadFail.submit();
            }
          }
          // this.exceldata.map((v, index) => {
          // });
        };
      },
      // 合计
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          if (index === 4 || index === 5 || index === 6 || index === 7) {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += " ";
            } else {
              sums[index] = "N/A";
            }
          }
        });

        return sums;
      },
      brforeUploadreImportFail(file) {
        this.loading = true;
        let params = new FormData();
        params.append("file", file);
        params.append("file", URL.createObjectURL(file));
        params.append("cfid", this.informdata.id);
        console.log(file, "开始上传");
        this.$axios({
          method: "post",
          url: "CommonModule/ImportExcel/UploadExcel_StockInfo",
          headers: { "Content-Type": "multipart/form-data" },
          data: params,
          timeout: 30000000,
        }).then((res) => {
          console.log(res, "上传结果");
          this.loading = false;

          if (res.data.Success) {
            this.$message({
              howClose: true,
              message: "导入成功，请确认无误后，点击提交，完成库存提报！",
              type: "success",
            });
            this.GetInquiryInfo();
          } else {
            if (res.data.Code == "-2") {
              this.GetErrorInfo();
            } else {
            }
            this.$message.error(res.data.Message);
          }
        });

        return false; //屏蔽了action的默认上传
      },
      // 获取错误信息
      GetErrorInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/ImportExcel/GetStockErrorInfo",
          data: { cfid: this.informdata.id },
        }).then((res) => {
          console.log(res, "获取错误信息");
          this.loading = false;
          if (res.data.Success) {
            this.errordatajson = [];
            this.errordatajson = res.data.Data;
            if (this.errordatajson.length == 0) {
              this.$message.error("暂无错误数据！");
            } else {
              this.dialogFormVisible = true;
              // setTimeout(() => {
              //   this.exportExcelerror();
              // }, 200);
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 导出错误信息
      exportExcelerror() {
        /* 从表生成工作簿对象 */
        var wb = XLSX.utils.table_to_book(document.querySelector("#out-table1"), {
          raw: true,
        });
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            //Blob 对象表示一个不可变、原始数据的类文件对象。
            //Blob 表示的不一定是JavaScript原生格式的数据。
            //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
            //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
            new Blob([wbout], { type: "application/octet-stream" }),
            //设置导出文件名称
            "错误信息.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }

        return wbout;
      },
      closesad() {
        this.dialogFormVisible = false;
      },
      // 导出
      exportExcel() {
        /* 从表生成工作簿对象 */
        var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
          raw: true,
        });
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            //Blob 对象表示一个不可变、原始数据的类文件对象。
            //Blob 表示的不一定是JavaScript原生格式的数据。
            //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
            //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
            new Blob([wbout], { type: "application/octet-stream" }),
            //设置导出文件名称
            "库存填报信息.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
      //  暂存
      SavePrice() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SubmitStockSave",
          data: {
            KeyId: this.suprow.id,
            tableinfo: JSON.stringify(this.tableData),
          },
        }).then((res) => {
          console.log(res, "暂存结果");
          if (res.data.Success) {
            this.$message.success(res.data.Message);
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 判断调价暂存和提报
      checktable(type) {
        this.tableData.forEach((item, index) => {
          // let no = index + 1;
          if (item.ibanchengpin_3 == "") {
            item.ibanchengpin_3 = 0;
          } else if (item.ichengpin_3 === "") {
            item.ichengpin_3 = 0;
          } else if (item.izaitu_3 === "") {
            item.izaitu_3 = 0;
          } else if (item.iyxdwsc_3 === "") {
            item.iyxdwsc_3 = 0;
          }
        });
        if (type == "1") {
          this.SavePrice();
        }
        if (type == "2") {
          this.PriceSubmit();
        }
      },
      //  提报
      PriceSubmit() {
        this.$confirm(
          "此操作将提报该信息内容，提报之后将无法修改请确认是否提报",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/SubmitStockCommit",
              data: {
                KeyId: this.suprow.id,
                tableinfo: JSON.stringify(this.tableData),
                cremaks: this.informdata.cremaks,
              },
            }).then((res) => {
              console.log(res, "提报结果");
              if (res.data.Success) {
                this.$message.success("提报成功！！");
                this.removerp();
                this.returnpage("1");
              } else {
                this.$message.error(res.data.Message);
              }
            });
          })
          .catch(() => { });
      },

      // 删除待办事项中的信息
      removerp() {
        RemovePruchaseToDo({
          KeyValue: this.suprow.id,
        }).then((res) => {
          console.log(res);
        });
      },
      //  撤销报价
      UnPriceSubmit() {
        this.$confirm("此操作将撤销报价，请确认是否操作！！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/SubmitStockUnCommit",
              data: { KeyId: this.suprow.id },
            }).then((res) => {
              console.log(res, "撤销结果");
              if (res.data.Success) {
                this.$message.success(res.data.Message);
                this.informdata.cvensubmit = "未提报";
                if (this.informdata.cvensubmit == "已提报") {
                  this.tibaoif = true;
                } else {
                  this.tibaoif = false;
                }
              } else {
                this.$message.error(res.data.Message);
              }
            });
          })
          .catch(() => { });
      },

      //  报价详情
      rowClassName({ row, rowIndex }) {
        //把每一行的索引放进row.id
        row.id = rowIndex + 1;
      },
    },
    beforeDestroy() {
      this.informdata = {};
    },
  };
</script>
<style scoped>
  .el-card__header .clearfix span {
    font-size: 12px;
  }

  .tb-edit .el-input,
  .tb-edit .el-select,
  .tb-edit .el-textarea {
    display: none;
  }

  .tb-edit .current-row .el-input,
  .tb-edit .current-row .el-select,
  .tb-edit .current-row .el-textarea {
    display: block;
  }

  .tb-edit .current-row .el-input+span,
  .tb-edit .current-row .el-select+span,
  .tb-edit .current-row .el-textarea+span {
    display: none;
  }

  .infodata {
    margin-bottom: 10px;
  }

  .infodata span {
    margin: 0 10px;
  }
</style>